import { ResponsiveBarSvgProps, BarDatum } from "@nivo/bar";
import BarChart from "./bar";

import LineBarChart from "./lineBar";
import RadialChart from "./radial";
import LineChart from "./line";
import LinearChart from "./linear";
// import ProgressBar from "./progress/circularAndLinearProgress";
import PieChart from "./pie";
import PieAndProgress from "./pieAndProgress";
import CustomLinearProgress from "./progress/linearProgress";
import CustomCircularProgress from "./progress/circularProgress";
import MapVector from "./vectorMap";
import SankeyChart from "./sankey";
import MyDataGrid from "./dataGrid";
import HeatMapChart from "./heatMap";
import BarHorizontal from "./barHorizontal";
import Repeat from "./repeat";

const DynamicChart: React.FC<DashGraphicsConfig> = (props) => {
  if (!props.config || !props || !props.type) {
    return <>Configurações Inválidas</>;
  }

  if (props.type === "bar") {
    return <BarChart {...props.config} metricsType={props.metricsType} />;
  }
  if (props.type === "barHorizontal") {
    return <BarHorizontal {...props.config} />;
  }
  if (props.type === "radial") {
    return <RadialChart {...props.config} metricsType={props.metricsType} />;
  }
  if (props.type === "lineBar") {
    return <LineBarChart {...props.config} metricsType={props.metricsType} />;
  }
  if (props.type === "line") {
    return <LineChart {...props.config} metricsType={props.metricsType} />;
  }
  if (props.type === "linear") {
    return <LinearChart {...props.config} />;
  }
  if (props.type === "circular-progress") {
    return <CustomCircularProgress {...props.config} />;
  }
  if (props.type === "linear-progress") {
    return <CustomLinearProgress {...props.config} />;
  }
  if (props.type === "pie") {
    if (props.subType === "donutAndProgress") {
      return (
        <PieAndProgress {...props.config} metricsType={props.metricsType} />
      );
    }
    return <PieChart {...props.config} metricsType={props.metricsType} />;
  }
  if (props.type === "vectorMap") {
    return <MapVector {...props.config} metricsType={props.metricsType} />;
  }
  if (props.type === "sankey") {
    return <SankeyChart {...props.config} metricsType={props.metricsType} />;
  }
  if (props.type === "datagrid") {
    return <MyDataGrid {...props.config} />;
  }

  if (props.type === "heatMap") {
    return <HeatMapChart {...props.config} id={`heatmap-${props.id}`} />;
  }

  if (props.type === "repeat") {
    return (
      <Repeat
        {...props}
        updateCard={props.updateCard}
        deleteCard={props.deleteCard}
        duplicateCard={props.duplicateCard}
        id={props.idCard}
        selectedFilter={props.selectedFilter}
        paginaId={props.paginaId}
        firstLoading={props.firstLoading}
        filtersInitialized={props.filtersInitialized}
        loading={props.loading}
      />
    );
  }

  return <>Configurações Inválidas</>;
};

export default DynamicChart;
